var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"x-small":"","color":_vm.color}},[_vm._v("mdi-circle")])
}
var staticRenderFns = []

export { render, staticRenderFns }